import { url } from "./url_config";

export async function login(email, password) {
    try {
        const response = await fetch(`${url}auth/login?email=${email}&password=${password}`, {
            headers: {
                "Content-Type": "application/json"
            }
        });

        const data = await response.json();
        await new Promise(resolve => setTimeout(resolve, 750));

        if (!response.ok) {
            if (response.status === 401) {
                throw new Error("Credenciales invalidas");
            } else {
                throw new Error(data.message || "Error al iniciar sesión");
            }
        }

        return data;

    } catch (e) {
        console.error("login error:", e);
        throw e;
    }
}